<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.listaPremii')}} </h4>
        </div>
        <div class="add-prize" v-if="$can(['create prize'])">
            <button class="template-button" @click="$router.push('/prizes/create')">
                <i class="fas fa-plus-circle"></i>
                {{$t('txt.adaugaPremiu')}}
            </button>
        </div>
        <div class="account-points-wrapper">
            <div class="account-points-inner">
                <i class="far fa-star"></i>
                <div class="account-points-header">
                    <span> {{$t('placeholder.puncteleMele')}} </span>
                    <span> {{userPoints}}</span>
                </div>
            </div>
        </div>
        <div class="prizes-container">
            <div class="prizes-inner">
                <div class="single-prize" v-for="(prize, index) in prizes" :key="prize.id">
                    <div class="prize-wrapper">
                        <div class="prize-image" v-if="prize.files.length > 0">
                            <img :src="prize.files[0].link">
                        </div>
                        <div class="prize-overlay">
                        </div>
                        <div class="prize-name">
                            <h4> {{prize.title}} </h4>
                        </div>
                        <div class="prize-description">
                            <p>
                                {{prize.description}}
                            </p>
                        </div>
                    </div>
                    <div class="prize-cost">
                        <i class="far fa-star"></i>
                        <p> {{prize.points}} </p>
                    </div>
                    <div class="claim-prize">
                        <button @click="takePrize(index, prize.id)">
                            {{$t('placeholder.revendicaPremiul')}}
                        </button>
                    </div>
                    <router-link :to="{ name: 'editprize', params: { id: prize.id }}"  v-if="$can(['update prize'])">
                        <div class="prize-tool-button edit-prize">
                            <i class="far fa-edit"></i>
                        </div>
                    </router-link>
                    <div class="prize-tool-button delete-prize" @click='removePrize(index, prize.id)' v-if="$can(['delete prize'])">
                        <i class="far fa-trash-alt"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrizesService from '../../api-services/prizes.service.js'
import UsersService from '../../api-services/users.service.js'
export default {
  name: 'prizes',
  data () {
    return {
      userPoints: null,
      prizes: null
    }
  },
  methods: {
    getPoints () {
      let userId = this.$store.getters.user.id
      UsersService.getPoints(userId)
        .then((response) => {
          this.userPoints = response.data.data.points
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    takePrize (index, prizeId) {
      let data = {
        id: prizeId,
        points: parseInt(document.getElementsByClassName('single-prize')[index].childNodes[1].children[1].innerHTML),
        user_id: this.$store.getters.user.id
      }
      PrizesService.createRequest(data)
        .then((response) => {
          this.$store.getters.user.points -= data.points
          localStorage.setItem('user', JSON.stringify(this.$store.getters.user))
          this.userPoints -= data.points
          console.log(response)
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.solicitareEfectuata'),
            'animation-type': 'css'
          })
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    getPrizes () {
      this.$store.dispatch('showLoading')
      PrizesService.getAll()
        .then((response) => {
          if (response.data.data.data.length > 0) {
            this.prizes = response.data.data.data
          } else {
            this.prizes = []
          }
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    removePrize (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergePremiul'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          PrizesService.delete(id)
            .then((response) => {
              this.$delete(this.prizes, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Premiul a fost sters cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    // Send and Apply query params in url
    applyQuery (params) {
      let resetPage = { page: '1' }
      let currentQuery = this.$route.query
      if (params.q) {
        this.searchBy = this.search
      }
      // params = _.pickBy(params)
      // merge 3 objects
      let query = { ...currentQuery, ...resetPage, ...params }
      this.$router.push({ name: 'prizesrequests', query: query })
    },
    // Apply sort params on column
    handleSort (column) {
      if (this.$route.query.sort_by === column && this.$route.query.sort_type === 'ASC') {
        this.applyQuery({ sort_by: column, sort_type: 'DESC' })
      } else {
        this.applyQuery({ sort_by: column, sort_type: 'ASC' })
      }
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.getPrizes()
    this.getPoints()
  }
}
</script>
